import { SVGProps } from 'react'

export const ReactIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={15}
    height={15}
    viewBox="0 0 40 40"
    fill="none"
    {...props}
  >
    <g clipPath="url(#react-a)">
      <path
        d="M19.983 23.386a3.206 3.206 0 1 0 0-6.411 3.206 3.206 0 0 0 0 6.411Z"
        fill="#61DAFB"
      />
      <path
        d="M19.983 26.748c9.5 0 17.202-2.94 17.202-6.567 0-3.628-7.702-6.568-17.202-6.568-9.5 0-17.201 2.94-17.201 6.568 0 3.627 7.701 6.567 17.201 6.567Z"
        stroke="#61DAFB"
      />
      <path
        d="M14.295 23.465c4.75 8.227 11.147 13.426 14.289 11.613 3.141-1.814 1.837-9.954-2.913-18.181C20.921 8.669 14.524 3.47 11.382 5.284c-3.14 1.813-1.837 9.953 2.913 18.18Z"
        stroke="#61DAFB"
      />
      <path
        d="M14.295 16.897c-4.75 8.227-6.054 16.367-2.912 18.18 3.14 1.814 9.538-3.385 14.288-11.612 4.75-8.228 6.054-16.368 2.913-18.181-3.142-1.814-9.539 3.385-14.289 11.613Z"
        stroke="#61DAFB"
      />
    </g>
    <defs>
      <clipPath id="react-a">
        <path fill="#fff" transform="translate(0 2)" d="M0 0h40v36.361H0z" />
      </clipPath>
    </defs>
  </svg>
)
